<template>
  <ValidationObserver v-slot="{ handleSubmit }">
    <form
      id="login-form"
      class="login-form custom-form"
      novalidate
      data-testid="login-form"
      @submit.prevent="handleSubmit(onSubmit)"
    >
      <ValidationProvider
        v-slot="{ errors }"
        mode="lazy"
        rules="required|email"
      >
        <fieldset
          class="login-form__field input__wrap"
          :class="{ 'error-focus': errors.length > 0 }"
        >
          <input
            id="userName"
            ref="userNameInput"
            v-model="email"
            :disabled="isPending"
            type="email"
            name="userName"
            data-testid="email-input"
            class="login-form__field__input required"
            :class="{
              error: errors.length > 0,
              valid: email.length > 0 && errors.length == 0,
            }"
            required
          >
          <label
            v-t="'INPUT_EMAIL'"
            for="userName"
            class="login-form__field__label"
          />
          <div
            v-if="errors.length > 0"
            class="error-tooltip__wrap"
            data-testid="email-error"
          >
            <h4
              v-t="'INPUT_EMAIL_ERROR'"
              class="menu-link text-uppercase error-tooltip__content"
            />
            <p
              v-t="'INPUT_EMAIL_ERROR_DESCRIPTION'"
              class="description"
            />
          </div>
        </fieldset>
      </ValidationProvider>
      <ValidationProvider
        v-slot="{ errors }"
        mode="lazy"
        rules="required"
      >
        <fieldset
          class="login-form__field input__wrap password__wrap"
          :class="{ 'error-focus': errors.length > 0 }"
        >
          <input
            id="password"
            ref="passwordInput"
            v-model="password"
            :type="passwordType"
            :disabled="isPending"
            name="password"
            data-testid="password-input"
            class="login-form__field__input password-has-icon required"
            :class="{
              error: errors.length > 0,
              valid: password.length > 0 && errors.length == 0,
            }"
            required
          >
          <label
            v-t="'INPUT_PASSWORD'"
            for="password"
            class="login-form__field__label"
          />
          <a
            class="icon--password fa fa-eye"
            data-testid="toggle-password-visibility"
            @click="showPassword"
          />
          <div 
            class="error-tooltip__wrap"
            data-testid="password-error"
          >
            <h4
              v-t="'INPUT_PASSWORD_ERROR'"
              class="menu-link text-uppercase error-tooltip__content"
            />
            <p
              v-t="'INPUT_PASSWORD_ERROR_DESCRIPTION'"
              class="description xxs-visible"
            />
          </div>
        </fieldset>
      </ValidationProvider>
      <fieldset
        class="login-form__field login-form__field--checkbox checkbox__wrap"
      >
        <input
          id="login.checkbox"
          v-model="remember"
          type="checkbox"
          name="signup.checkbox"
          data-testid="remember-me-checkbox"
          class="login-form__field__input--checkbox"
        >
        <label
          v-t="'INPUT_REMEMBER_ME'"
          for="login.checkbox"
          class="login-form__field__label login-form__field__label--checkbox"
        />
        <a
          id="forget-pass-link"
          v-t="'FORGOT_PASS_LINK'"
          href="#"
          data-testid="forgot-password-link"
          class="forget-pass-link"
          @click="forgotPassword"
        />
      </fieldset>
      <fieldset class="login-form__field login-form__field--button">
        <SubmitButton 
          :pending="isPending"
          data-testid="login-button"
        >
          {{ $t('LOGIN_BUTTON') }} 
        </SubmitButton>
      </fieldset>
      <transition name="backend-error-fade">
        <div
          v-show="showErrorMsg"
          class="text-center p-t-5"
          data-testid="backend-error-message"
        >
          <p
            class="text-danger"
          >
            {{ actionStatus.error }}
          </p>
        </div>
      </transition>
    </form>
  </ValidationObserver>
</template>

<script>
import { $ngStateService } from '@/angularBridgeCode/ringbaPortal.servicesModule';
import messages from '../locales';
import SubmitButton from '@/modules/auth/components/SubmitButton';
import { STATUS_PENDING, STATUS_ERROR } from '@/store/helpers';

export default {
  components: {
    SubmitButton,
  },
  props: {
    actionStatus: {
      type: Object,
      default() {
        return {};
      },
    }
  },
  data: function () {
    return {
      email: '',
      password: '',
      remember: true,
      passwordType: 'password'
    };
  },
  computed: {
    isPending() {
      return this.actionStatus.status === STATUS_PENDING;
    },
    showErrorMsg() {
      return this.actionStatus.status === STATUS_ERROR && this.actionStatus.error.length > 0;
    }
  },
  methods: {
    showPassword() {
      if (this.passwordType === 'password') {
        this.passwordType = 'text';
      } else {
        this.passwordType = 'password';
      }
    },
    forgotPassword() {
      $ngStateService.go('forgot-password');
    },
    onSubmit() {
      if (this.actionStatus.status !== STATUS_PENDING) {
        const { email, password, remember } = this;
        this.$emit('login', { email, password, remember });
      }
    },
  },
  i18n: {
    messages,
    locale: 'en',
  },
};
</script>